import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  inputArea: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    marginTop: '0.25rem',
    width: '100%'
  },

  input: {
    flex: '1'
  },

  button: {
    width: 'auto',
    height: 'auto'
  }
}))

export default useStyles
